/**
 * SHD Back in stock — show/hide + retag on Horizon variant changes.
 * Listens to variant:update / variant:selected, input[name="id"], and morphs.
 */
(function () {
  'use strict';

  var VARIANT_EVENTS = ['variant:update', 'variant:selected'];

  function parseVariantMap(root) {
    var map = {};
    var handle = '';
    var script =
      (root && root.parentElement && root.parentElement.querySelector('script[data-shd-bis-variants]')) ||
      document.querySelector('script[data-shd-bis-variants]');
    if (!script) return { map: map, handle: handle };
    try {
      var data = JSON.parse(script.textContent || '{}');
      handle = data.handle || '';
      (data.variants || []).forEach(function (v) {
        map[String(v.id)] = !!v.available;
      });
    } catch (e) {
      /* ignore bad JSON */
    }
    return { map: map, handle: handle };
  }

  function readSelectedVariantId(scope) {
    var root = scope || document;
    var inputs = root.querySelectorAll('input[name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (inp.disabled) continue;
      if (inp.type === 'radio' || inp.type === 'checkbox') {
        if (inp.checked && inp.value) return String(inp.value);
      } else if (inp.value) {
        return String(inp.value);
      }
    }
    var selects = root.querySelectorAll('select[name="id"]');
    for (var j = 0; j < selects.length; j++) {
      if (selects[j].value) return String(selects[j].value);
    }
    return null;
  }

  function availabilityFromEvent(e, map) {
    var d = e && e.detail;
    if (!d) return null;
    var resource = d.resource || d.variant || null;
    if (resource && typeof resource.available === 'boolean' && resource.id != null) {
      return { id: String(resource.id), available: !!resource.available };
    }
    if (resource && resource.id != null && map[String(resource.id)] !== undefined) {
      return { id: String(resource.id), available: !!map[String(resource.id)] };
    }
    return null;
  }

  function applyState(el, variantId, available, handle) {
    if (!el) return;
    var show = available === false;
    if (show) {
      el.hidden = false;
      el.classList.remove('shd-bis--hidden');
      el.removeAttribute('aria-hidden');
    } else {
      el.hidden = true;
      el.classList.add('shd-bis--hidden');
      el.setAttribute('aria-hidden', 'true');
    }
    if (variantId) {
      el.setAttribute('data-variant-id', String(variantId));
      var tags = el.querySelector('[data-shd-bis-tags]');
      var h = handle || el.getAttribute('data-product-handle') || '';
      if (tags && h) {
        tags.value = 'back-in-stock, bis-' + h + ', bis-vid-' + variantId;
      }
    }
  }

  function syncOne(el, hint) {
    var parsed = parseVariantMap(el);
    var map = parsed.map;
    var handle = parsed.handle || el.getAttribute('data-product-handle') || '';
    var variantId = null;
    var available = null;

    if (hint && hint.id) {
      variantId = String(hint.id);
      if (typeof hint.available === 'boolean') available = hint.available;
    }
    if (!variantId) {
      variantId = readSelectedVariantId(document) || el.getAttribute('data-variant-id');
    }
    if (available === null && variantId && map[String(variantId)] !== undefined) {
      available = map[String(variantId)];
    }
    if (available === null) {
      // Unknown: keep current visibility based on data-variant-id map miss → hide
      available = true;
    }
    applyState(el, variantId, available, handle);
  }

  function syncAll(hint) {
    document.querySelectorAll('[data-shd-bis]').forEach(function (el) {
      syncOne(el, hint);
    });
  }

  function onVariantEvent(e) {
    var el = document.querySelector('[data-shd-bis]');
    var parsed = parseVariantMap(el);
    var fromEvent = availabilityFromEvent(e, parsed.map);
    syncAll(fromEvent || undefined);
  }

  function onIdChange(e) {
    var t = e && e.target;
    if (!t) return;
    if (t.name === 'id' || (t.getAttribute && t.getAttribute('name') === 'id')) {
      var id = t.value;
      if (!id) return;
      var el = document.querySelector('[data-shd-bis]');
      var parsed = parseVariantMap(el);
      var available =
        parsed.map[String(id)] !== undefined ? parsed.map[String(id)] : null;
      syncAll({ id: id, available: available });
    }
  }

  var scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      syncAll();
    });
  }

  function init() {
    if (!document.querySelector('[data-shd-bis]')) return;
    syncAll();
    VARIANT_EVENTS.forEach(function (name) {
      document.addEventListener(name, onVariantEvent);
    });
    document.addEventListener('change', onIdChange, true);
    document.addEventListener('input', onIdChange, true);

    var root = document.querySelector('variant-picker') || document.querySelector('[data-product-id]') || document.body;
    if (root && typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(scheduleSync);
      mo.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value', 'checked', 'data-variant-id', 'disabled'],
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
